import type { Site } from '../Site';

export const TheMoneyEdit: Site = {
  id: 'themoneyedit',
  analyticsName: 'themoneyedit',
  selector: '',
  logo: '',
  label: 'The Money Edit',
  platform: '',
};
